import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=55b42af0&scoped=true"
import script from "./packageList.vue?vue&type=script&lang=js"
export * from "./packageList.vue?vue&type=script&lang=js"
import style0 from "./packageList.vue?vue&type=style&index=0&id=55b42af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b42af0",
  null
  
)

export default component.exports